import React from 'react'
import isServerSide from '@helpers/misc/isServerSide'
import {NextRouter,withRouter} from 'next/router'
import PropTypes from 'prop-types'

import withUserId from './withUserId'

export interface ForceLoginProps {
  router: NextRouter
  userId?: string
}

function ForceLogin(ComposedComponent: React.ComponentType<any>) {
  class ForceLogin extends React.Component<ForceLoginProps> {
    static propTypes = {
      history: PropTypes.object,
      userId: PropTypes.string
    }

    redirect() {
      if (isServerSide()) return null

      this.props.router.replace({
        pathname: '/login',
        query: {nextPathname: window.location.pathname}
      })
      return null
    }

    render() {
      if (!this.props.userId) return this.redirect()
      return <ComposedComponent {...this.props} />
    }
  }

  return withUserId(withRouter<ForceLoginProps>(ForceLogin))
}

export default ForceLogin
